import * as React from "react";
import { useState, useEffect } from "react";

/**
 * 알람, 공지사항을 알린다.
 * @returns
 */
export const FxValueInfo = (props) => {
  const { title, value, unit, subInfoList, sx } = props;

  useEffect(() => {
    console.log("*** FxValueInfo ***  title = " + title);
    console.log("*** FxValueInfo ***  value = " + value);
    console.log("*** FxValueInfo ***  unit = " + unit);
    console.log("*** FxValueInfo ***  subInfoList = ", subInfoList);
    console.log("*** FxValueInfo ***  sx = ", sx);
  }, []);

  return (
    <div className={"FxInfoDiv" + (sx ? " FxInfoDiv_" + sx : "")}>
      <h2>{title}</h2>
      <p>
        {value}
        <span> {unit}</span>
      </p>
      <ul className="FxInfoSubList">
        {subInfoList.map((info, index) => {
          return <li key={index}>{info}</li>;
        })}
      </ul>
    </div>
  );
};
